import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import * as visitTypes from '../../../redux/appointmentForm/requests/visit-types-req';
import withCareUserSubtitle from '../hocs/withCareUserSubtitle';
import { APPOINTMENT_HIDDEN_TYPES } from '../../../constants';
import {
  selectProgramBasedVisitId,
  selectProgressOrganization,
} from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  organization: selectProgressOrganization(state),
  programBasedVisitId: selectProgramBasedVisitId(state),
});
const mapDispatchToProps = {
  init: visitTypes.actions.init,
  selectVisitType: appointmentProgressActions.selectVisitType,
  selectProgramBasedVisit: appointmentProgressActions.selectProgramBasedVisit,
};

export const enhance = compose(
  injectIntl,
  withCareUserSubtitle,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ organization }) => ({
    programBasedVisits: organization.pbvConfigs || [],
    types: organization.visitTypes.filter(
      ({ code }) => !APPOINTMENT_HIDDEN_TYPES.includes(code),
    ),
  })),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentVisitType/enhance.js